import formatSeconds from './format-seconds';

export { formatSeconds };

export default formatSeconds;
